module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-battery.661f0b0a.mp4";